import React from "react";
import { motion } from "framer-motion";
import { PRESS } from "@/lib/data";

export const Press = () => (
  <section data-testid="press-section" className="py-24 md:py-32 bg-ink-900/40 border-y border-white/5">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="text-xs tracking-[0.4em] uppercase text-gold mb-10">
        ◢ The World is Talking
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {PRESS.map((p, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            data-testid={`press-quote-${i}`}
            className="bg-ink-950 p-8 md:p-10 hover:bg-ink-900 transition-colors"
          >
            <div className="text-gold font-serif text-4xl leading-none mb-4">"</div>
            <p className="font-serif italic text-lg md:text-xl text-slate-200 leading-snug">
              {p.quote}
            </p>
            <div className="mt-6 text-[10px] tracking-[0.3em] uppercase text-cyan-glow">
              — {p.source}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
